import {register} from '../../../assets/js/modules/eventMap';
import {ACTIVE_CLASS} from './constants';

const init = (el) => {
    const input = el.previousElementSibling;

    if (!el || !input) {
        return;
    }

    if (!el.dataset.kindeControlAddonButtonTextInitial) {
        el.dataset.kindeControlAddonButtonTextInitial =
            el.getAttribute('aria-label');
    }

    const initialLabel = el.dataset.kindeControlAddonButtonTextInitial;
    const actionedLabel = el.dataset.kindeControlAddonButtonTextActioned;

    el.classList.toggle(ACTIVE_CLASS);

    const isActive = el.classList.contains(ACTIVE_CLASS);
    const label = isActive ? actionedLabel : initialLabel;

    el.setAttribute('aria-label', label);
    el.setAttribute('title', label);
    input.type = isActive ? 'text' : 'password';
};

const togglePasswordInputType = () => {
    register('togglePasswordInputType', {init});
};

export {togglePasswordInputType};
